'use client';
import React, { FC } from 'react';

import styled from 'styled-components';

import { FiltersProvider } from '@contexts/Filters';
import { SearchViewModel } from '@api/models/SearchViewModel';
import { SearchURLProvider } from '@api/data-loaders/resource';

import HotelListing from './HotelListing';
const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.backgroundColor};
`;

export interface IHotelListingScreen {
  searchData?: SearchViewModel | null;
}

const HotelListingScreen: FC<IHotelListingScreen> = ({ searchData }) => (
  <SearchURLProvider value={searchData || null}>
    <Container>
      <FiltersProvider>
        <HotelListing />
      </FiltersProvider>
    </Container>
  </SearchURLProvider>
);

export default HotelListingScreen;
